import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';
import actions from './index';

export const ACTIONS = {
  GET: 'ONLINE_PLAN_GET',
  GET_SUCCESS: 'ONLINE_PLAN_GET_SUCCESS',
  GET_FAILURE: 'ONLINE_PLAN_GET_FAILURE',

  GET_ALL: 'ONLINE_PLAN_GET_ALL',
  GET_ALL_SUCCESS: 'ONLINE_PLAN_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'ONLINE_PLAN_GET_ALL_FAILURE',

  POST: 'ONLINE_PLAN_POST',
  POST_SUCCESS: 'ONLINE_PLAN_POST_SUCCESS',
  POST_FAILURE: 'ONLINE_PLAN_POST_FAILURE',

  PATCH: 'ONLINE_PLAN_PATCH',
  PATCH_SUCCESS: 'ONLINE_PLAN_PATCH_SUCCESS',
  PATCH_FAILURE: 'ONLINE_PLAN_PATCH_FAILURE',

  INVALIDATE_LIST: 'ONLINE_PLAN_INVALIDATE_ALL',
  INVALIDATE_ITEM: 'ONLINE_PLAN_INVALIDATE_ITEM',
};

export const patch = actions.patch(
  planId => `${BASE_URL}/pricing/online-plans/${planId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const get = actions.get(
  (bandId, query) =>
    `${BASE_URL}/pricing/online-plans/?band_id=${bandId}&${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const getAll = actions.getAll(
  (query, meta) => `${BASE_URL}/pricing/online-plans/`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
